import React from "react"
// import { Values } from "redux-form-website-template";
import { API_SERVER, API_DEBUG } from "../../restClient"

export const ValuesForm = ({ isDebug, formName = "record-form" }) => {
  if (API_SERVER === API_DEBUG && isDebug) {
    return <div style={{ width: 400 }}>{/* <Values form={formName} /> */}</div>
  }
  return null
}

export const checkNumber = (v) => {
  if (v.length > 0) {
    return isNaN(v) ? undefined : parseFloat(v)
  }
  return isNaN(v) ? 0 : v
}



// WEBPACK FOOTER //
// ./src/components/form/ValuesForm.js